import { Component, State, h, Prop, Watch } from '@stencil/core';
import state from '@ugc-store';
import { PageType } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-page-summary',
  shadow: false,
})
export class UgcPageSummary {
  @Prop() productId: number;
  @Prop() pageType: PageType = PageType.review;
  @State() isShowAll = false;

  async componentWillLoad() {
    this.isShowAll = false;
  }

  @Watch('productId')
  async watchProductIdHandler() {
    this.isShowAll = false;
  }

  handleClick() {
    this.isShowAll = !this.isShowAll;
  }
  render() {
    const {
      reviewStaticLanguage: { IDS_FDA_DISCLAIMER = '', IDS_AS_SHOW_MORE = '', IDS_AS_SHOW_LESS = '' } = {},
      qnaStaticLanguage: { IDS_UGC_ANSWERS_DISCLAIMER = '' } = {},
      ids: reviewIds = [],
      qids: questionIds = [],
      isDesktop,
      isShowReviewSkeleton,
    } = state;
    if (isShowReviewSkeleton) return null;
    const isQna = this.pageType === PageType.qna;
    if (
      (this.pageType === PageType.review && !reviewIds.length) ||
      (this.pageType === PageType.qna && !questionIds.length)
    )
      return null;
    const content = isQna ? IDS_UGC_ANSWERS_DISCLAIMER : IDS_FDA_DISCLAIMER;

    if (isDesktop)
      return (
        <div class={`${!this.isShowAll && 'flex-row-start-center'} mt-8 mb-16`}>
          <span
            class={`fs-14 color-gray-500 ${!this.isShowAll && 'truncate max-width-60'}`}
            style={{ width: '60%' }}
            tabIndex={0}
          >
            {content}&nbsp;
          </span>
          <button class="fs-14 color-blue-dark pointer border-0 bg-white p-0" onClick={this.handleClick.bind(this)}>
            {this.isShowAll ? IDS_AS_SHOW_LESS : IDS_AS_SHOW_MORE}
          </button>
        </div>
      );

    return (
      <div class="mt-4">
        <span class={`ft-12 color-gray-500 ${!this.isShowAll && 'ellipsis-text-2'}`}>{content}&nbsp;</span>
        <button class="fs-12 color-blue-dark pointer border-0 bg-white p-0" onClick={this.handleClick.bind(this)}>
          {this.isShowAll ? IDS_AS_SHOW_LESS : IDS_AS_SHOW_MORE}
        </button>
      </div>
    );
  }
}
